import { useTranslation } from 'react-i18next';

import { Body1, Flex } from '@myphx-engineering/phx-design-system';

import { formatToLocalizedCurrency } from '../../../../util';
import { ConditionalComponent } from '../../../utility/ConditionalComponent';

type DeductibleAmountProps = {
    amount?: number | null;
};

export const DeductibleAmount = ({ amount }: DeductibleAmountProps) => {
    const { t } = useTranslation();

    return (
        <ConditionalComponent condition={!!amount}>
            <Flex justify="space-between">
                <Body1>{t('claimHistory.claimDetails.amountApplied')}</Body1>
                <Body1 data-testid="claim-history-details-amount-to-deductible">
                    {formatToLocalizedCurrency(amount!)}
                </Body1>
            </Flex>
        </ConditionalComponent>
    );
};
